import { useEffect, useRef } from "react";

export function DiscardChangesDialog({
  open,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
    return () => {
      if (dialog.open) dialog.close();
    };
  }, [open]);
  return (
    <dialog
      ref={dialogRef}
      className="shift-pin-dialog shift-discard-dialog"
      aria-labelledby="shift-discard-title"
      aria-describedby="shift-discard-description"
      onCancel={(event) => {
        event.preventDefault();
        onCancel();
      }}
    >
      <h2 id="shift-discard-title">Kaydedilmemiş bilgiler var</h2>
      <p id="shift-discard-description">
        Devam ederseniz son yazdıklarınız kaybolur. Önce kaydetmek için forma
        dönebilirsiniz.
      </p>
      <div className="shift-pin-dialog-actions">
        <button
          type="button"
          className="is-primary"
          autoFocus
          onClick={onCancel}
        >
          Forma dön
        </button>
        <button type="button" onClick={onConfirm}>
          Kaydetmeden devam et
        </button>
      </div>
    </dialog>
  );
}
